import { getPublicLang, setPublicLang, usePublicLanguage } from "./publicLanguage";

export { getPublicLang, setPublicLang };

export const PUBLIC_COPY = {
  de: {
    lang: { de: "DE", en: "EN" },
    audience: {
      title: "Wer bist du?",
      options: {
        care: {
          title: "Pflegeeinrichtung",
        },
        family: {
          title: "Familienmitglied",
        },
      },
    },
    familyLanding: {
      assets: {
        mobileHeroBackground: "/homepage/mobile/universal/steffi_blue.png",
        mobileVoiceBackground: "/homepage/mobile/universal/steffi_three.png",
        mobileConversationVideo: "/homepage/mobile/universal/conversation_video.mp4",
        familyFeedWallpaper: "/homepage/image_wallpaper.png",
        mobileFamilyFeedDetails: "/homepage/mobile/de/feed_news.png",
        mobileFamilyFeedTiles: [
          "/homepage/mobile/de/feed_album.png",
          "/homepage/mobile/de/message.png",
          "/homepage/mobile/de/feed_video.png",
        ],
        familyFeedPhotosTile: "/homepage/mobile/de/photos_share.png",
        familyFeedMediaTile: "/homepage/mobile/de/feed_iphone.png",
        familyFeedChatTile: "/homepage/desktop/de/chat.png",
        familyFeedBackgrounds: [
          "/homepage/desktop/de/feed_album.jpeg",
          "/homepage/desktop/de/message.jpeg",
          "/homepage/desktop/de/feed_video.jpeg",
        ],
        everydaySupportTiles: [
          "/homepage/desktop/de/emergency.png",
          "/homepage/mobile/de/calendar.png",
          "/homepage/mobile/de/reminders.png",
        ],
      },
      back: "Auswahl ändern",
      eyebrow: "Für Angehörige",
      title: "Steffi, der digitale Begleiter für Senioren",
      subtitle: "Mehr Nähe, mehr Teilhabe und Sicherheit im Alltag",
      login: "Auf die Warteliste",
      finalTitlePrefix: "Einfach",
      finalTitleHighlight: "Steffi",
      finalTitleSuffix: "rufen und losprechen, losgelöst von Befehlen. Steffi versteht natürliche Sprache.",
      secondFinalTitle:
        "Steffi ist mehr als ein klassischer Sprachassistent. Steffi ist ein aktiver Gesprächsteilnehmer.",
      secondFinalBullets: [
        "Steffi erinnert sich an Interessen, Gewohnheiten und wiederkehrende Themen.",
        "Steffi stellt Rückfragen, knüpft an frühere Gespräche an und macht Unterhaltungen persönlicher.",
      ],
      secondFinalDesktop: {
        headlineName: "Steffi",
        headlineText:
          "ist mehr als ein klassischer Sprachassistent. Steffi ist ein aktiver Gesprächsteilnehmer.",
        cards: [
          {
            icon: "memory",
            text: "Steffi erinnert sich an Interessen, Gewohnheiten und wiederkehrende Themen.",
            highlight: "erinnert sich",
          },
          {
            icon: "conversation",
            text: "Steffi stellt Rückfragen, knüpft an frühere Gespräche an und macht Unterhaltungen persönlicher.",
            highlight: "stellt Rückfragen",
          },
        ],
      },
      secondFinalMobile: {
        title: "Mehr als ein\nSprachassistent.",
        highlight: "Ein Gesprächspartner,\nder mitdenkt.",
      },
      postFifthTitle:
        "Führe über Steffi Videotelefonate. \n\nUm abzuheben drücke einfach auf Steffi drauf.",
      postFifthBullets: [
        "Steffi verfügt über einen 5-Zoll-großen runden Bildschirm.",
        "Steffi hat eine 12-Megapixel-Weitwinkelkamera.",
      ],
      postFifthDesktop: {
        headlinePrefix: "Führe",
        headlineHighlight: "über Steffi",
        headlineSuffix: "Videotelefonate.",
        leadPrefix: "Um abzuheben drücke einfach auf",
        leadHighlight: "Steffi",
        leadSuffix: "drauf.",
        cards: [
          {
            icon: "display",
            text: "Steffi verfügt über einen 5-Zoll-großen runden Bildschirm.",
            highlight: "5-Zoll-großen",
          },
          {
            icon: "camera",
            text: "Steffi hat eine 12-Megapixel-Weitwinkelkamera.",
            highlight: "12-Megapixel-Weitwinkelkamera",
          },
        ],
      },
      postFifthSpecs: [
        { text: "Ein 5 Zoll großer HD-Bildschirm" },
        { text: "12-Megapixel-Weitwinkelkamera" },
      ],
      postFifthMobile: {
        eyebrow: "Videoanrufe mit Steffi",
        title: "Führe über Steffi",
        highlight: "Videotelefonate.",
        instructionPrefix: "Um abzuheben drücke einfach auf",
        instructionHighlight: "Steffi",
        instructionSuffix: "drauf.",
        cards: [
          {
            icon: "display",
            title: "Ein 5 Zoll großer\nHD-Bildschirm",
            text: "Klare Sicht für persönliche Gespräche.",
          },
          {
            icon: "camera",
            title: "12-Megapixel-\nWeitwinkelkamera",
            text: "Für gestochen scharfe Bilder und eine natürliche Verbindung.",
          },
        ],
      },
      finalNote: "ideal für Menschen, die mit Technik wenig vertraut sind.",
      familyFeedTitle: "Teile Inhalte im Family Feed",
      familyFeedTiles: [
      {
          title: "Fotoalben",
          subtitle:
            "Lasse deine Liebsten mit Fotos und Videos an schönen Momenten teilhaben. Steffi zeigt geteilte Inhalte direkt an und kann sie als digitalen Bilderrahmen wiedergeben.",
        },
        {
          title: "Nachrichten",
          subtitle:
            "Schicke persönliche Nachrichten, Sprachnachrichten oder kurze Videobotschaften. Steffi macht neue Nachrichten sichtbar, liest sie auf Wunsch vor und ermöglicht eine einfache Antwort per Sprache.",
        },
        {
          title: "Medieninhalte",
          subtitle:
            "Teile interessante Inhalte wie YouTube-Videos, Webseiten, Nachrichten oder Rezepte. Steffi bereitet sie so auf, dass sie auch ohne Smartphone oder Tablet leicht zugänglich sind.",
          supportedLabel: "Unterstützt auch",
        },
      ],
      everydaySupportTitle: "Unterstütze im Alltag",
      everydaySupportTiles: [
        {
          title: "Notfallanrufe",
          subtitle:
            "Sorge dafür, dass im Ernstfall schnell jemand erreicht wird. Bei „Hilfe Steffi“ ruft Steffi die hinterlegten Notfallkontakte automatisch nacheinander an.",
          subtitleHighlight: "Hilfe Steffi",
        },
        {
          title: "Gemeinsamer Kalender",
          subtitle:
            "Organisiere Termine wie Arztbesuche, Geburtstage oder Familienbesuche gemeinsam über die App. Steffi erinnert rechtzeitig und verständlich daran.",
        },
        {
          title: "Erinnerungen",
          subtitle:
              "Erstelle Erinnerungen für Medikamente, Trinken oder tägliche Routinen. Steffi erinnert zur richtigen Zeit und hilft, den Alltag besser zu strukturieren.",
        },
      ],
      collageIntroTitle: "Zugang zur digitalen Welt. Mehr Selbstständigkeit im Alltag.",
      collageIntroSubtitle:
        "Viele digitale Möglichkeiten bleiben älteren Menschen verschlossen, weil Apps, Handys und Tablets zu kompliziert sind. Steffi bündelt sie in einem einfachen, sprachgesteuerten Gerät, optimiert für ältere Menschen.",
      collageIntroSupportedLabel: "Unterstützt",
      collageIntroSupportedServices: ["Spotify", "YouTube", "Google-Suche"],
      collageIntroBubbles: [
        { title: "Wetter", prompt: "Wie wird das Wetter heute?" },
        { title: "Video", prompt: "Spiel die aktuelle Tagesschau ab." },
        { title: "Kochrezepte", prompt: "Zeig mir ein einfaches Rezept für Pfannkuchen." },
        { title: "Sprachnachricht", prompt: "Schick meiner Tochter eine Sprachnachricht." },
        { title: "Fotos", prompt: "Zeig mir die neuesten Fotos von meiner Familie." },
        { title: "Kalender", prompt: "Wann kommt morgen mein Besuch?" },
        { title: "Aktivierung", prompt: "Mach eine kleine Gedächtnisübung mit mir." },
        { title: "Bewegung", prompt: "Zeig mir eine leichte Übung im Sitzen." },
        { title: "Notfall", prompt: "Hilfe Steffi." },
        { title: "Radio", prompt: "Spiel meinen Lieblingssender." },
        { title: "Gespräch", prompt: "Erzähl mir etwas über Italien." },
        { title: "Quiz", prompt: "Ich möchte ein Quiz spielen." },
      ],
      activationRoutine: {
        eyebrow: "Aktivierungsroutinen",
        title: "Mehr Aktivität",
        description:
          "Erstelle Aktivierungsroutinen, damit Steffi proaktiv den Nutzer anspricht und passende Aktivitäten vorschlägt. Dazu gehören zum Beispiel kognitive Spiele, einfache Gespräche, leichte körperliche Übungen oder weitere Tätigkeiten, die geistige und körperliche Aktivierung fördern.",
        gamesTitle: "Kognitive Übungen",
        gamesDescription:
          "Steffi schlägt passende Aufgaben vor, die Gedächtnis, Sprache und Aufmerksamkeit trainieren.",
        companionTitle: "Steffi spielt mit",
        companionDescription:
          "Steffi ist keine reine Spieleplattform. Sie begleitet interaktive Spiele im Gespräch, erklärt Regeln und spielt mit.",
        physicalTitle: "Körperliche Übungen",
        physicalDescription:
          "Steffi motiviert dazu, sich körperlich zu betätigen, und schlägt einfache Übungen für mehr Bewegung im Alltag vor.",
      },
      waitlist: {
        title: "Auf die Warteliste",
        description:
          "Trage deine E-Mail-Adresse ein und sei eine der ersten Personen, die informiert werden, sobald Steffi verfügbar ist.",
        emailPlaceholder: "Deine E-Mail-Adresse",
        submit: "Abschicken",
        submitting: "Wird gesendet…",
        success: "Fast geschafft. Bitte bestätige deine Anmeldung über den Link in deiner E-Mail. Schau auch im Spamordner nach.",
        error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
        close: "Schließen",
        consentLabel: "Ja, ich möchte über den Launch von SteffiCare informiert werden.",
        privacyPrefix: "Mehr Informationen im",
        privacyLinkLabel: "Datenschutzhinweis",
      },
    },
    landing: {
      nav_contact: "Kontakt",
      nav_login: "Login",
      for_family: "Für Angehörige",
      hero_title_line1: "Der",
      hero_title_em: "KI Begleiter",
      hero_title_line2: "für die Pflege",
      hero_body:
        "Pflege, die mehr kann, als nur zu versorgen. SteffiCare bietet Bewohnern Gesellschaft, individuelle Übungen und mehr Selbständigkeit im Leben.",
      hero_cta: "Am Pilotprojekt teilnehmen",
      supported_by: "Unterstützt durch:",
      next_section_aria: "Zum nächsten Abschnitt",
    },
    header: {
      cta: "Am Pilotprojekt teilnehmen →",
    },
    features: {
      items: [
        {
          title: "Interaktive Übungen",
          body:
            "Über Sprache können Bewohner kognitive, motorische und sprachliche Übungen durchführen, die an ihre individuellen Fähigkeiten angepasst werden können.",
        },
        {
          title: "Alltagsunterstützung",
          body:
            "Ob durch Erinnerungen an Termine, Einnahme von Medikamenten oder den Zugang zum Speiseplan und Veranstaltungen, SteffiCare hilft Bewohnern, ihren Alltag selbständig zu meistern.",
        },
        {
          title: "Proaktive Kommunikation",
          body:
            "SteffiCare startet Gespräche in über 15 Sprachen, um Einsamkeit vorzubeugen und Bewohner aktiv in den Alltag einzubinden. Dabei lernt die KI die Vorlieben der Nutzer kennen und passt Gespräche entsprechend an.",
        },
        {
          title: "Barrierefreier Medienzugang",
          body:
            "Bewohner können Musik, Hörbücher, Radio, Nachrichten und viele weitere Medieninhalte barrierefrei per Sprachbefehl abrufen. Durch den Zugang zum Internet sind die Möglichkeiten nahezu unbegrenzt.",
        },
        {
          title: "Dashboard für Personal",
          body:
            "Über das Dashboard können Pflegekräfte zentral Erinnerungen, Veranstaltungen, Speisepläne und mehr steuern. Bewohner können so individuell alle relevanten Informationen abrufen.",
        },
        {
          title: "Datenschutz und Sicherheit",
          body:
            "SteffiCare ist ein deutsches Forschungsprojekt, das höchsten Datenschutz und Sicherheitsstandards entspricht. Gespräche werden nicht gespeichert. Alle Datenschutzoptionen sind transparent einsehbar.",
        },
      ],
    },
    dashboard: {
      title: "Optimiere Laufwege und schaffe neue Möglichkeiten in der sozialen Betreuung.",
      assets: {
        macbookImages: [
          "/homepage/desktop/de/macbook_calendar.png",
          "/homepage/desktop/de/macbook_reminders.png",
          "/homepage/desktop/de/macbook_profile.png",
        ],
      },
      items: [
        {
          title: "Halte alle Bewohner auf dem neuesten Stand.",
          description:
            "Im Dashboard lassen sich Veranstaltungen, Speisepläne oder Arzttermine ganz einfach eintragen und verwalten. SteffiCare informiert die Bewohner automatisch, erfasst ihre Rückmeldungen zur Teilnahme und hält alle barrierefrei auf dem neuesten Stand.",
        },
        {
          title: "Konfiguriere Erinnerungen",
          description:
            "Ob Trinkerinnerungen, der Besuch der Tochter oder eine Wasserabsperrung, mit Steffi lassen sich Hinweise einfach und gezielt an einzelne Personen oder Gruppen weitergeben. Bei Bedarf kannst du Bewohner direkt anrufen oder eine Durchsage senden.",
        },
        {
          title: "Keine Steffi ist gleich",
          description:
            "Über die Profileinstellungen können Interessen, Gewohnheiten und persönliche Biografien der Bewohner hinterlegt werden. SteffiCare verfügt über ein Langzeitgedächtnis und merkt sich alle relevanten Details. So entstehen Gespräche, die einzigartig und individuell abgestimmt auf jede einzelne Person sind, für mehr Nähe, Verständnis und persönliche Ansprache im Alltag.",
        },
      ],
      image_alt_prefix: "SteffiCare Screenshot",
    },
    speech_cards: {
      cards: [
        "Erinnere Antonia an den Besuch ihrer Tochter",
        "Erinnere Wolfgang an das Mittagessen um 12 Uhr",
      ],
      aria_play: "Abspielen",
      aria_pause: "Pause",
      device_alt: "SteffiCare Gerät",
    },
    sticky: {
      title: "So können Bewohner mit Steffi reden",
      bubbles: [
        "Hey {steffi}, was gibt es heute zu essen?",
        "Hey {steffi}, welche Kurse finden heute statt?",
        "Hey {steffi}, ich möchte ein Spiel spielen",
      ],
      bottom: "Reagiert blitzschnell auf “Hey Steffi”",
      aria_play: "Audio abspielen",
      aria_pause: "Audio pausieren",
      play_label: "Abspielen",
      pause_label: "Pause",
    },
    faq: {
      title: "FAQs",
      items: [
        {
          q: "Was ist der Unterschied zu anderen Sprachassistenzgeräten wie Alexa oder Google Echo?",
          a:
            "SteffiCare wurde speziell für Pflegeeinrichtungen entwickelt und richtet sich gezielt an die Bedürfnisse älterer Menschen. Es ist besonders leicht zu bedienen und unterscheidet sich von klassischen Sprachassistenten: STEFFI beantwortet nicht nur Fragen, sondern führt empathische Gespräche und geht auf die Person hinter der Stimme ein. Gleichzeitig können Pflegekräfte über das Dashboard wichtige Informationen und Erinnerungen eintragen.",
        },
        {
          q: "Was benötige ich für die Einrichtung?",
          a:
            "Für die Einrichtung benötigen Sie lediglich eine Internetverbindung (WLAN) und eine Steckdose. Je nachdem in welchem Umfang Sie SteffiCare nutzen möchten, können Sie zusätzliche Funktionen über das Dashboard konfigurieren.",
        },
        {
          q: "Was passiert mit den Daten. Hört SteffiCare immer zu?",
          a:
            "Gespräche werden standardmäßig nur lokal auf dem Gerät gespeichert. SteffiCare hört nur zu, wenn es durch den Aufruf 'Hey STEFFI' aktiviert wird. Nach 60 Sekunden ohne Aktivität wird das Gerät automatisch wieder in den Standbymodus versetzt. Durch die LED Leuchte am Gerät ist jederzeit ersichtlich, ob SteffiCare aktiv zuhört.",
        },
        {
          q: "Was kostet SteffiCare?",
          a:
            "Da es sich bei SteffiCare um ein Forschungsprojekt handelt, bieten wir das Gerät aktuell nicht zum Verkauf an. Interessierte Pflegeeinrichtungen können sich jedoch für Pilotprojekte bewerben. Kontaktieren Sie uns gerne für weitere Informationen.",
        },
      ],
    },
    contact: {
      title: "Haben Sie Fragen?",
      button: "Termin auswählen",
      phone_label: "Oder ruft uns einfach an:",
      phone: "+4917660962402",
      email_text: "Bei Supportanfragen schreibt uns gerne an:",
      email: "contact@stefficare.com",
    },
    footer_black: {
      title: "Sind Sie bereit, die Pflege auf die nächste Stufe zu heben?",
      cta: "Am Pilotprojekt teilnehmen",
      contact_title: "Kontakt",
      phone_label: "Telefon:",
      email_label: "Email:",
      address_lines: ["Breitkopfstraße 91", "13409 Berlin", "Deutschland"],
    },
    footer: {
      terms: "Nutzungsbedingungen",
      imprint: "Impressum",
      privacy: "Datenschutzhinweis",
    },
    contact_footer: {
      eyebrow: "",
      title_lines: ["Haben Sie Fragen?"],
      description: "",
      actions_label: "Kontaktaktionen",
      actions: [
        { label: "Termin buchen", href: "/termin", variant: "primary", icon: "calendar" },
      ],
      info_items: [
        { icon: "phone", label: "Telefon", lines: ["+4917660962402"], href: "tel:+4917660962402" },
        { icon: "email", label: "Email", lines: ["contact@stefficare.com"], href: "mailto:contact@stefficare.com" },
      ],
      follow_label: "Folgen Sie uns",
      social_links: [
        { label: "LinkedIn", href: "https://www.linkedin.com/company/stefficare/about/", icon: "linkedin" },
        { label: "YouTube", href: "https://m.youtube.com/@stefficare_official?ra=m", icon: "youtube" },
      ],
      newsletter: {
        title: "Newsletter abonnieren",
        description:
          "Verpassen Sie keine Neuigkeiten",
        placeholder: "Ihre Emailadresse",
        label: "Abonnieren",
        submittingLabel: "Wird gespeichert...",
        successMessage: "Fast geschafft. Bitte bestätigen Sie Ihre Anmeldung über den Link in Ihrer E-Mail. Schauen Sie auch im Spamordner nach.",
        errorMessage: "Die Email konnte nicht gespeichert werden.",
        consentLabel: "Ja, ich möchte über den Launch von SteffiCare informiert werden.",
        privacyPrefix: "Mehr Informationen im",
        privacyLinkLabel: "Datenschutzhinweis",
        note: "",
        href: "#",
      },
      response_time: "",
      form: {
        title: "Nachricht senden",
        fields: [
          { label: "Vollständiger Name", placeholder: "Max Mustermann", type: "text" },
          { label: "Emailadresse", placeholder: "name@beispiel.de", type: "email" },
          { label: "Nachricht", placeholder: "Wie können wir Ihnen helfen?", type: "textarea" },
        ],
        submitLabel: "Nachricht senden",
        submittingLabel: "Wird gesendet...",
        successMessage: "Vielen Dank. Ihre Nachricht wurde gesendet.",
        errorMessage: "Etwas ist schiefgelaufen.",
      },
      brand: {
        title: "SteffiCare",
        description:
          "Moderne KI Begleitung für Pflegeeinrichtungen: persönlich, barrierefrei und darauf ausgelegt, Bewohner und Teams im Alltag zu entlasten.",
        socialLinks: [
          { label: "LinkedIn", href: "https://www.linkedin.com/company/stefficare/about/", icon: "linkedin" },
          { label: "YouTube", href: "https://m.youtube.com/@stefficare_official?ra=m", icon: "youtube" },
        ],
      },
      footer_columns: [
        {
          title: "Quick Links",
          links: [
            { label: "Kontakt", href: "#kontaktformular" },
            { label: "LinkedIn", href: "https://www.linkedin.com/company/stefficare/about/" },
            { label: "YouTube", href: "https://m.youtube.com/@stefficare_official?ra=m" },
          ],
        },
        {
          title: "Informationen",
          lines: [
            "Telefon: +4917660962402",
            "Email: contact@stefficare.com",
            "Adresse: Breitkopfstraße 91, 13409 Berlin",
          ],
        },
      ],
      bottom_bar: {
        copyright: "© 2026 SteffiCare. Alle Rechte vorbehalten.",
        address: "Breitkopfstraße 91, 13409 Berlin, Deutschland",
        links: [
          { label: "Datenschutzhinweis", href: "/datenschutzhinweis" },
          { label: "Nutzungsbedingungen", href: "/nutzungsbedingungen" },
        ],
      },
    },
    legal: {
      impressum: {
        title: "Impressum",
        sections: [
          {
            title: "Angaben gemäß § 5 TMG",
            lines: ["Erik Rubinov", "Breitkopfstraße 91", "13409 Berlin"],
          },
          {
            title: "Kontakt",
            lines: ["E-Mail:"],
            email: "contact@stefficare.com",
          },
          {
            title: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
            lines: ["Erik Rubinov", "Breitkopfstraße 91", "13409 Berlin"],
          },
          {
            title: "Haftung für Inhalte",
            body:
              "Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
          },
          {
            title: "Haftung für Links",
            body:
              "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
          },
          {
            title: "Urheberrecht",
            body:
              "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
          },
        ],
      },
      agb: {
        title: "Allgemeine Geschäftsbedingungen",
        sections: [
          {
            title: "§ 1 Geltungsbereich",
            body:
              "Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen Erik Rubinov (nachfolgend \"Anbieter\") und seinen Kunden über die Nutzung der SteffiCare Dienstleistungen.",
          },
          {
            title: "§ 2 Vertragspartner",
            lines: ["Vertragspartner ist:", "Erik Rubinov", "Breitkopfstraße 91", "13409 Berlin"],
            email: "contact@stefficare.com",
          },
          {
            title: "§ 3 Leistungen",
            body:
              "Der Anbieter entwickelt und vertreibt KI-gestützte Sprachassistenzsysteme, insbesondere für den Einsatz in Pflegeeinrichtungen. Die konkreten Leistungen werden in individuellen Verträgen festgelegt.",
          },
          {
            title: "§ 4 Vertragsschluss",
            body:
              "Ein Vertrag kommt durch die Annahme eines Angebots des Anbieters oder durch die Bestätigung einer Bestellung des Kunden durch den Anbieter zustande.",
          },
          {
            title: "§ 5 Preise und Zahlungsbedingungen",
            body:
              "Die Preise verstehen sich als Nettopreise zuzüglich der gesetzlichen Mehrwertsteuer. Zahlungen sind innerhalb von 14 Tagen nach Rechnungsstellung fällig.",
          },
          {
            title: "§ 6 Gewährleistung",
            body:
              "Es gelten die gesetzlichen Gewährleistungsbestimmungen. Der Anbieter gewährleistet, dass die gelieferte Software zum Zeitpunkt der Übergabe frei von Rechtsmängeln ist.",
          },
          {
            title: "§ 7 Haftung",
            body:
              "Die Haftung des Anbieters ist auf Vorsatz und grobe Fahrlässigkeit beschränkt. Dies gilt nicht für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.",
          },
          {
            title: "§ 8 Datenschutz",
            body:
              "Der Anbieter verpflichtet sich, alle datenschutzrechtlichen Bestimmungen einzuhalten und personenbezogene Daten nur im Rahmen der gesetzlichen Bestimmungen zu verarbeiten.",
          },
          {
            title: "§ 9 Schlussbestimmungen",
            body:
              "Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
          },
        ],
      },
      datenschutz: {
        title: "Datenschutzerklärung",
        updated_label: "Letzte Aktualisierung:",
      },
    },
    calendly: {
      back: "← Zurück",
    },
  },
  en: {
    lang: { de: "DE", en: "EN" },
    audience: {
      title: "Who are you?",
      options: {
        care: {
          title: "Care facilities",
        },
        family: {
          title: "Family member",
        },
      },
    },
    familyLanding: {
      assets: {
        mobileHeroBackground: "/homepage/mobile/universal/steffi_blue.png",
        mobileVoiceBackground: "/homepage/mobile/universal/steffi_three.png",
        mobileConversationVideo: "/homepage/mobile/universal/conversation_video.mp4",
        familyFeedWallpaper: "/homepage/image_wallpaper.png",
        mobileFamilyFeedDetails: "/homepage/mobile/en/feed_news.png",
        mobileFamilyFeedTiles: [
          "/homepage/mobile/en/feed_album.png",
          "/homepage/mobile/en/message.png",
          "/homepage/mobile/en/feed_video.png",
        ],
        familyFeedPhotosTile: "/homepage/mobile/en/photos_share.png",
        familyFeedMediaTile: "/homepage/mobile/en/feed_iphone.png",
        familyFeedChatTile: "/homepage/desktop/en/chat.png",
        familyFeedBackgrounds: [
          "/homepage/desktop/en/feed_album.jpeg",
          "/homepage/desktop/en/message.png",
          "/homepage/desktop/en/feed_video.jpeg",
        ],
        everydaySupportTiles: [
          "/homepage/desktop/en/emergency.png",
          "/homepage/mobile/en/calendar.png",
          "/homepage/mobile/en/reminders.png",
        ],
      },
      back: "Change selection",
      eyebrow: "For relatives",
      title: "Steffi, the digital companion for seniors",
      subtitle: "More closeness, more participation, and safety in everyday life",
      login: "Join the waitlist",
      finalTitlePrefix: "Just call",
      finalTitleHighlight: "Steffi",
      finalTitleSuffix:
        "and start talking, free from commands. Steffi understands natural language.",
      secondFinalTitle:
        "Steffi is more than a classic voice assistant. Steffi is an active conversation partner.",
      secondFinalBullets: [
        "Steffi remembers interests, habits, and recurring topics.",
        "Steffi asks follow-up questions, picks up on earlier conversations, and makes conversations more personal.",
      ],
      secondFinalDesktop: {
        headlineName: "Steffi",
        headlineText:
          "is more than a classic voice assistant. Steffi is an active conversation partner.",
        cards: [
          {
            icon: "memory",
            text: "Steffi remembers interests, habits, and recurring topics.",
            highlight: "remembers",
          },
          {
            icon: "conversation",
            text: "Steffi asks follow-up questions, picks up on earlier conversations, and makes conversations more personal.",
            highlight: "asks follow-up questions",
          },
        ],
      },
      secondFinalMobile: {
        title: "More than a\nvoice assistant.",
        highlight: "A conversation partner\nwho thinks along.",
      },
      postFifthTitle:
        "Make video calls through Steffi.\n\nTo answer, simply press Steffi.",
      postFifthBullets: [
        "Steffi has a 5-inch round screen.",
        "Steffi has a 12-megapixel wide-angle camera.",
      ],
      postFifthDesktop: {
        headlinePrefix: "Make video calls",
        headlineHighlight: "through Steffi.",
        headlineSuffix: "",
        leadPrefix: "To answer, simply press",
        leadHighlight: "Steffi",
        leadSuffix: ".",
        cards: [
          {
            icon: "display",
            text: "Steffi has a 5-inch round screen.",
            highlight: "5-inch",
          },
          {
            icon: "camera",
            text: "Steffi has a 12-megapixel wide-angle camera.",
            highlight: "12-megapixel wide-angle camera",
          },
        ],
      },
      postFifthSpecs: [
        { text: "A large 5-inch HD display" },
        { text: "12-megapixel wide-angle camera" },
      ],
      postFifthMobile: {
        eyebrow: "Video calls with Steffi",
        title: "Make video calls",
        highlight: "through Steffi.",
        instructionPrefix: "To answer, simply press",
        instructionHighlight: "Steffi",
        instructionSuffix: ".",
        cards: [
          {
            icon: "display",
            title: "A large 5-inch\nHD display",
            text: "Clear visibility for personal conversations.",
          },
          {
            icon: "camera",
            title: "12-megapixel\nwide-angle camera",
            text: "For sharp images and a natural connection.",
          },
        ],
      },
      finalNote: "Ideal for people who are less familiar with technology.",
      familyFeedTitle: "Share content in the Family Feed",
      familyFeedTiles: [
        {
          title: "Photo Albums",
          subtitle:
            "Let your loved ones share in beautiful moments through photos and videos. Steffi displays shared content directly and can play it back as a digital picture frame.",
        },
        {
          title: "Messages",
          subtitle:
            "Send personal messages, voice messages, or short video messages. Steffi makes new messages visible, reads them aloud on request, and enables a simple voice reply.",
        },
        {
          title: "Media content",
          subtitle:
            "Share interesting content such as YouTube videos, websites, news, or recipes. Steffi prepares it so it is easy to access even without a smartphone or tablet.",
          supportedLabel: "Also supports",
        },
      ],
      everydaySupportTitle: "Support in everyday life",
      everydaySupportTiles: [
        {
          title: "Emergency calls",
          subtitle:
            "Make sure someone can be reached quickly in an emergency. When the user says “Help Steffi”, Steffi automatically calls the saved emergency contacts one after another.",
          subtitleHighlight: "Help Steffi",
        },
        {
          title: "Shared calendar",
          subtitle:
            "Organize appointments such as doctor visits, birthdays, or family visits together through the app. Steffi reminds users in good time and in a way they can understand.",
        },
        {
          title: "Reminders",
          subtitle:
            "Create reminders for medication, drinking, or daily routines. Steffi reminds users at the right time and helps structure everyday life.",
        },
      ],
      collageIntroTitle: "Access to the digital world. More independence in everyday life.",
      collageIntroSubtitle:
        "Many digital possibilities remain out of reach for older people because apps, phones, and tablets are too complicated. Steffi brings them together in a simple voice-controlled device, optimized for older adults.",
      collageIntroSupportedLabel: "Supports",
      collageIntroSupportedServices: ["Spotify", "YouTube", "Google Search"],
      collageIntroBubbles: [
        { title: "Weather", prompt: "What will the weather be like today?" },
        { title: "Video", prompt: "Play the latest news." },
        { title: "Recipes", prompt: "Show me an easy pancake recipe." },
        { title: "Voice message", prompt: "Send my daughter a voice message." },
        { title: "Photos", prompt: "Show me the latest photos of my family." },
        { title: "Calendar", prompt: "When is my visitor coming tomorrow?" },
        { title: "Activation", prompt: "Do a short memory exercise with me." },
        { title: "Movement", prompt: "Show me a light seated exercise." },
        { title: "Emergency", prompt: "Help Steffi." },
        { title: "Radio", prompt: "Play my favorite station." },
        { title: "Conversation", prompt: "Tell me something about Italy." },
        { title: "Quiz", prompt: "I want to play a quiz." },
      ],
      activationRoutine: {
        eyebrow: "Activation routines",
        title: "More activity",
        description:
          "Create activation routines so Steffi proactively addresses the user and suggests suitable activities. These include cognitive games, simple conversations, light physical exercises, and other activities that support mental and physical activation.",
        gamesTitle: "Cognitive exercises",
        gamesDescription:
          "Steffi suggests suitable tasks that train memory, language, and attention.",
        companionTitle: "Steffi plays along",
        companionDescription:
          "Steffi is not just a game platform. It accompanies interactive games in conversation, explains rules, and plays along.",
        physicalTitle: "Physical exercises",
        physicalDescription:
          "Steffi encourages users to be physically active and suggests simple exercises for more movement in everyday life.",
      },
      waitlist: {
        title: "Join the waitlist",
        description:
          "Enter your email address and be one of the first people to be informed as soon as Steffi is available.",
        emailPlaceholder: "Your email address",
        submit: "Submit",
        submitting: "Sending…",
        success: "Almost done. Please confirm your subscription using the link in your email. Please also check your spam folder.",
        error: "Something went wrong. Please try again.",
        close: "Close",
        consentLabel: "Yes, I would like to be informed about the launch of SteffiCare.",
        privacyPrefix: "More information in the",
        privacyLinkLabel: "privacy notice",
      },
    },
    landing: {
      nav_contact: "Contact",
      nav_login: "Login",
      for_family: "For families",
      hero_title_line1: "The",
      hero_title_em: "AI companion",
      hero_title_line2: "for care",
      hero_body:
        "Care that does more than just provide support. SteffiCare offers residents companionship, individualized exercises, and greater independence in daily life.",
      hero_cta: "Join the pilot program",
      supported_by: "Supported by:",
      next_section_aria: "Next section",
    },
    header: {
      cta: "Join the pilot program →",
    },
    features: {
      items: [
        {
          title: "Interactive exercises",
          body:
            "Residents can use voice to complete cognitive, motor, and language exercises tailored to their individual abilities.",
        },
        {
          title: "Everyday support",
          body:
            "Whether reminders for appointments, taking medication, or access to menus and events, SteffiCare helps residents manage their daily lives independently.",
        },
        {
          title: "Proactive communication",
          body:
            "SteffiCare starts conversations in more than 15 languages to prevent loneliness and actively engage residents. The AI learns user preferences and adapts conversations accordingly.",
        },
        {
          title: "Accessible media",
          body:
            "Residents can access music, radio, news, and more via voice commands. With internet access, possibilities are nearly unlimited.",
        },
        {
          title: "Dashboard for staff",
          body:
            "Care staff can centrally manage reminders, events, meal plans, and more via the dashboard. Residents can retrieve relevant information individually.",
        },
        {
          title: "Privacy and security",
          body:
            "SteffiCare is a German research project that meets the highest privacy and security standards. Conversations are not stored. All privacy options are transparent.",
        },
      ],
    },
    dashboard: {
      title: "Optimize routes and create new possibilities in social care.",
      assets: {
        macbookImages: [
          "/homepage/desktop/en/macbook_calendar.png",
          "/homepage/desktop/en/macbook_reminders.png",
          "/homepage/desktop/en/macbook_profile.png",
        ],
      },
      items: [
        {
          title: "Keep all residents up to date.",
          description:
            "In the dashboard, events, meal plans, and doctor appointments can be added and managed easily. SteffiCare informs residents automatically, captures their feedback about participation, and keeps everyone up to date in an accessible way.",
        },
        {
          title: "Configure reminders",
          description:
            "Whether hydration reminders, a daughter’s visit, or a water shutoff, Steffi makes it easy to send messages simply and precisely to individuals or groups. If needed, you can call residents directly or send an announcement.",
        },
        {
          title: "No two Steffis are the same",
          description:
            "In the profile settings, interests, habits, and personal biographies can be stored. SteffiCare has long-term memory and remembers all relevant details. This creates conversations that are unique and tailored to each individual, bringing more closeness, understanding, and personal connection to everyday life.",
        },
      ],
      image_alt_prefix: "SteffiCare Screenshot",
    },
    speech_cards: {
      cards: [
        "Remind Antonia about her daughter’s visit",
        "Remind Wolfgang about lunch at 12 o’clock",
      ],
      aria_play: "Play",
      aria_pause: "Pause",
      device_alt: "SteffiCare device",
    },
    sticky: {
      title: "How residents can talk to Steffi",
      bubbles: [
        "Hey {steffi}, what’s for lunch today?",
        "Hey {steffi}, which classes are happening today?",
        "Hey {steffi}, I want to play a game",
      ],
      bottom: "Responds instantly to “Hey Steffi”",
      aria_play: "Play audio",
      aria_pause: "Pause audio",
      play_label: "Play",
      pause_label: "Pause",
    },
    faq: {
      title: "FAQs",
      items: [
        {
          q: "What is the difference to other voice assistants like Alexa or Google Echo?",
          a:
            "SteffiCare was developed specifically for care facilities and the needs of older adults. It is easy to use and differs from classic voice assistants: STEFFI doesn’t just answer questions, it leads empathetic conversations and responds to the person behind the voice. Care staff can add important information and reminders via the dashboard.",
        },
        {
          q: "What do I need for setup?",
          a:
            "You only need an internet connection (WiFi) and a power outlet. Depending on how extensively you want to use SteffiCare, you can configure additional functions through the dashboard.",
        },
        {
          q: "What happens to the data? Does SteffiCare always listen?",
          a:
            "Conversations are stored locally on the device by default. SteffiCare only listens when activated by the wake word “Hey STEFFI”. After 60 seconds of inactivity, the device returns to standby. The LED on the device always shows whether SteffiCare is listening.",
        },
        {
          q: "How much does SteffiCare cost?",
          a:
            "As SteffiCare is a research project, the device is not currently for sale. Interested care facilities can apply for pilot projects. Contact us for more information.",
        },
      ],
    },
    contact: {
      title: "Do you have questions?",
      button: "Choose a time",
      phone_label: "Or just call us:",
      phone: "+4917660962402",
      email_text: "For support inquiries, email us at:",
      email: "contact@stefficare.com",
    },
    footer_black: {
      title: "Ready to take care to the next level?",
      cta: "Join the pilot program",
      contact_title: "Contact",
      phone_label: "Phone:",
      email_label: "Email:",
      address_lines: ["Breitkopfstraße 91", "13409 Berlin", "Germany"],
    },
    footer: {
      terms: "Terms of Use",
      imprint: "Imprint",
      privacy: "Privacy notice",
    },
    contact_footer: {
      eyebrow: "",
      title_lines: ["Do you have questions?"],
      description: "",
      actions_label: "Contact actions",
      actions: [
        { label: "Book a call", href: "/termin", variant: "primary", icon: "calendar" },
      ],
      info_items: [
        { icon: "phone", label: "Phone", lines: ["+4917660962402"], href: "tel:+4917660962402" },
        { icon: "email", label: "Email", lines: ["contact@stefficare.com"], href: "mailto:contact@stefficare.com" },
      ],
      follow_label: "Follow us",
      social_links: [
        { label: "LinkedIn", href: "https://www.linkedin.com/company/stefficare/about/", icon: "linkedin" },
        { label: "YouTube", href: "https://m.youtube.com/@stefficare_official?ra=m", icon: "youtube" },
      ],
      newsletter: {
        title: "Subscribe newsletter",
        description:
          "Do not miss new updates",
        placeholder: "Your email address",
        label: "Subscribe",
        submittingLabel: "Saving...",
        successMessage: "Almost done. Please confirm your subscription using the link in your email. Please also check your spam folder.",
        errorMessage: "The email could not be saved.",
        consentLabel: "Yes, I would like to be informed about the launch of SteffiCare.",
        privacyPrefix: "More information in the",
        privacyLinkLabel: "privacy notice",
        note: "",
        href: "#",
      },
      response_time: "",
      form: {
        title: "Send a message",
        fields: [
          { label: "Full name", placeholder: "John Doe", type: "text" },
          { label: "Email address", placeholder: "john@example.com", type: "email" },
          { label: "Message", placeholder: "How can we help you?", type: "textarea" },
        ],
        submitLabel: "Send message",
        submittingLabel: "Sending...",
        successMessage: "Thanks. Your message has been sent.",
        errorMessage: "Something went wrong.",
      },
      brand: {
        title: "SteffiCare",
        description:
          "Modern AI companionship for care facilities that supports residents and care teams with accessible, human centered assistance.",
        socialLinks: [
          { label: "LinkedIn", href: "https://www.linkedin.com/company/stefficare/about/", icon: "linkedin" },
          { label: "YouTube", href: "https://m.youtube.com/@stefficare_official?ra=m", icon: "youtube" },
        ],
      },
      footer_columns: [
        {
          title: "Quick Links",
          links: [
            { label: "Contact", href: "#kontaktformular" },
            { label: "LinkedIn", href: "https://www.linkedin.com/company/stefficare/about/" },
            { label: "YouTube", href: "https://m.youtube.com/@stefficare_official?ra=m" },
          ],
        },
        {
          title: "Information",
          lines: [
            "Phone: +4917660962402",
            "Email: contact@stefficare.com",
            "Address: Breitkopfstraße 91, 13409 Berlin",
          ],
        },
      ],
      bottom_bar: {
        copyright: "© 2026 SteffiCare. All rights reserved.",
        address: "Breitkopfstraße 91, 13409 Berlin, Germany",
        links: [
          { label: "Privacy notice", href: "/datenschutzhinweis" },
          { label: "Terms of Use", href: "/nutzungsbedingungen" },
        ],
      },
    },
    legal: {
      impressum: {
        title: "Imprint",
        sections: [
          {
            title: "Information according to § 5 TMG",
            lines: ["Erik Rubinov", "Breitkopfstraße 91", "13409 Berlin"],
          },
          {
            title: "Contact",
            lines: ["Email:"],
            email: "contact@stefficare.com",
          },
          {
            title: "Responsible for content according to § 55 Abs. 2 RStV",
            lines: ["Erik Rubinov", "Breitkopfstraße 91", "13409 Berlin"],
          },
          {
            title: "Liability for content",
            body:
              "As a service provider, we are responsible for our own content on these pages in accordance with § 7 Abs.1 TMG and general laws. According to §§ 8 to 10 TMG, however, we are not obliged to monitor transmitted or stored third‑party information or to investigate circumstances that indicate illegal activity.",
          },
          {
            title: "Liability for links",
            body:
              "Our offer contains links to external third‑party websites whose content we have no influence over. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the linked sites is always responsible for their content.",
          },
          {
            title: "Copyright",
            body:
              "The content and works created by the site operators on these pages are subject to German copyright law. Reproduction, editing, distribution, and any kind of exploitation beyond the limits of copyright require the written consent of the respective author or creator.",
          },
        ],
      },
      agb: {
        title: "Terms and Conditions",
        sections: [
          {
            title: "§ 1 Scope",
            body:
              "These Terms and Conditions apply to all contracts between Erik Rubinov (hereinafter \"Provider\") and customers regarding the use of SteffiCare services.",
          },
          {
            title: "§ 2 Contractual partner",
            lines: ["Contractual partner is:", "Erik Rubinov", "Breitkopfstraße 91", "13409 Berlin"],
            email: "contact@stefficare.com",
          },
          {
            title: "§ 3 Services",
            body:
              "The Provider develops and distributes AI‑powered voice assistant systems, in particular for use in care facilities. The specific services are defined in individual contracts.",
          },
          {
            title: "§ 4 Conclusion of contract",
            body:
              "A contract is concluded by acceptance of an offer from the Provider or by confirmation of an order by the Provider.",
          },
          {
            title: "§ 5 Prices and payment terms",
            body:
              "Prices are net plus statutory VAT. Payments are due within 14 days of invoicing.",
          },
          {
            title: "§ 6 Warranty",
            body:
              "Statutory warranty provisions apply. The Provider warrants that the delivered software is free of defects at the time of transfer.",
          },
          {
            title: "§ 7 Liability",
            body:
              "The Provider’s liability is limited to intent and gross negligence. This does not apply to damages resulting from injury to life, body, or health.",
          },
          {
            title: "§ 8 Data protection",
            body:
              "The Provider undertakes to comply with all data protection regulations and to process personal data only within the scope of legal requirements.",
          },
          {
            title: "§ 9 Final provisions",
            body:
              "The law of the Federal Republic of Germany applies. If individual provisions of these Terms are invalid, the validity of the remaining provisions remains unaffected.",
          },
        ],
      },
      datenschutz: {
        title: "Privacy Policy",
        updated_label: "Last updated:",
      },
    },
    calendly: {
      back: "← Back",
    },
  },
};

export function usePublicLang() {
  const { lang, setLang } = usePublicLanguage();
  const copy = PUBLIC_COPY[lang] || PUBLIC_COPY.de;
  return { lang, setLang, copy };
}
